import { render, staticRenderFns } from "./AddInboundItemsModal.vue?vue&type=template&id=4e803ad2&scoped=true&"
import script from "./AddInboundItemsModal.vue?vue&type=script&lang=js&"
export * from "./AddInboundItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddInboundItemsModal.vue?vue&type=style&index=0&id=4e803ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e803ad2",
  null
  
)

export default component.exports